class Map {

    constructor() {
        this.hovers();
        // this.click();
        this.svg();
    }

    hovers() {
        $('[data-svg-link]')
            .on('mouseenter click', (e) => {
                setTimeout(() => {
                    $('[data-svg-key]').removeClass('active');
                    $('[data-svg-key="' + $(e.currentTarget).attr('data-svg-link') + '"]').addClass('active');
                }, 200);

                if ($(window).width() < 1200) {
                    var elem = $('[data-svg-key="' + $(e.currentTarget).attr('data-svg-link') + '"]:eq(0)');

                    scroller.to(elem, false, -150);
                    $('.map-block-svg').scrollLeft(0);
                    $('.map-block-svg').animate({
                        scrollLeft: elem.offset().left - $(window).width() / 2,
                    }, 400);

                    setTimeout(() => {
                        $('[data-svg-key]').addClass('active');
                    }, 1500);
                }
            })
            .on('mouseleave', (e) => {
                setTimeout(() => {
                    $('[data-svg-key]').addClass('active');
                }, 200)
            });

        $('[data-svg-key]')
            .on('mouseenter click', (e) => {
                setTimeout(() => {
                    $('[data-svg-link="' + $(e.currentTarget).attr('data-svg-key') + '"]').addClass('active');
                    $('[data-svg-key]').removeClass('active');
                    $('[data-svg-key="' + $(e.currentTarget).attr('data-svg-key') + '"]').toggleClass('active');
                }, 200)
            })
            .on('mouseleave', (e) => {
                setTimeout(() => {
                    $('[data-svg-link]').removeClass('active');
                    $('[data-svg-key]').addClass('active');
                }, 200)
            });
    }

    svg() {
        if ($(window).width() < 768) {
            $('.map-block-svg').scrollLeft(220);
        }
    }

    // click() {
    //     $('[data-svg-link]').on('click', (e) => {
    //         var elem = $('[data-svg-key="' + $(e.currentTarget).attr('data-svg-link') + '"]:eq(0)');

    //         if ($(window).width() < 1200) {
    //             scroller.to(elem, false, -150);
    //             $('.map-block-svg').scrollLeft(0);
    //             $('.map-block-svg').animate({
    //                 scrollLeft: elem.offset().left - $(window).width() / 2,
    //             }, 400);

    //             $(document).animate({
    //                 top: $(this).scrollTop(elem.offset().top - $(window).height() / 2)
    //             });

    //             setTimeout(() => {
    //                 $('[data-svg-key]').addClass('active');
    //             }, 1500);
    //         }
    //     });
    // }
}

new Map()